import script from "./ListarPessoasJuridicas.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarPessoasJuridicas.vue?vue&type=script&setup=true&lang=js"

import "./ListarPessoasJuridicas.vue?vue&type=style&index=0&id=754cab9c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-754cab9c"]])

export default __exports__